import { useContext } from "react";
import Flimp from "./containers/Editor";
import { LocalesContext } from "./context/localesContext";
import { VersionHistoryContext } from "./context/versionHistoryContext";
import { ToolbarContext } from "./context/ToolbarContext";
import Joyride, { EVENTS } from "react-joyride";
const FlimpStudio = () => {
  const { changeLocale, defaultLocale } = useContext(LocalesContext);
  const { state: versionHistoryState } = useContext(VersionHistoryContext);
  const { tool, setTool } = useContext(ToolbarContext);
  return (
    <div>
      <Flimp changeLocale={changeLocale} defaultLocale={defaultLocale}
        showHistory={versionHistoryState.showHistory}
        tool={tool}
        setTool={setTool}
        joyride={{}}
      />
    </div>
  );
};

export default FlimpStudio;
